import Vue from "vue";

export const mutations = {
  SET_LOADER: (state, payload: boolean): boolean => Vue.set(state, "loader", payload),
  SET_EMAILS: (state, payload) => Vue.set(state, "emails", payload),
  SET_RESET_PASSWORD_USER_EMAIL: (state, payload: string): string => Vue.set(state, "resetPasswordEmail", payload)
}
